import React from "react"

import { Bee } from "~/src/components/BeeKit"

export function DashboardToaster() {
  return <Bee.Toaster position="top-right" />
}
